<template>
    <Dialog :header="'Training Results for ' + workspace.label" v-model:visible="model" modal style="width: 85vw;" data-cy="training-results-dialog">
        <DataTable v-model:filters="filters" :value="results" filterDisplay="menu" sortField="user" removableSort :loading="loading" data-cy="training-results-table">
            <template #header>
                <div class="flex justify-end">
                    <IconField>
                        <InputIcon>
                            <i class="pi pi-search" />
                        </InputIcon>
                        <InputText v-model="filters.global.value" placeholder="Search all columns" data-cy="training-results-search" />
                    </IconField>
                </div>
            </template>
            <Column key="user" field="user" header="User" sortable>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Filter by user" @input="filterCallback()" />
                </template>
            </Column>
            <Column key="graph" field="graph" header="Graph" sortable>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Filter by graph" @input="filterCallback()" />
                </template>
            </Column>
            <Column key="score" field="score" header="Score" sortable dataType="numeric">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Filter by score" @input="filterCallback()" />
                </template>
            </Column>
            <Column key="max_score" field="max_score" header="Max Score" sortable dataType="numeric">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Filter by max score" @input="filterCallback()" />
                </template>
            </Column>
            <Column key="used_hints" field="used_hints" header="Used Hints" sortable dataType="numeric">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Filter by used hints" @input="filterCallback()" />
                </template>
            </Column>
        </DataTable>
    </Dialog>
</template>
<script setup>
import { ref, watch } from "vue";
import { FilterMatchMode } from "@primevue/core/api";
import { useStore } from "vuex";
import WorkspaceModel from "@/src/model/WorkspaceModel";
import {OP, trackPending, usePending} from "@/src/queries/pending";
import {getTrainingResults} from "@/src/api/workspaces";

const model = defineModel({
    type: Boolean,
    required: true
})

const props = defineProps({
    workspace: { type: WorkspaceModel, required: true }
})

const store = useStore();

const results = ref([])
const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user: { value: null, matchMode: FilterMatchMode.CONTAINS },
    graph: { value: null, matchMode: FilterMatchMode.CONTAINS },
    score: { value: null, matchMode: FilterMatchMode.EQUALS },
    max_score: { value: null, matchMode: FilterMatchMode.EQUALS },
    used_hints: { value: null, matchMode: FilterMatchMode.EQUALS },
})

const getResults = async () => {
    results.value = await trackPending(OP.FETCH_TRAINING_RESULTS, () => getTrainingResults(props.workspace.id))
}

const loading = usePending(OP.FETCH_TRAINING_RESULTS)

watch(model, async (newVal) => {
    if (newVal) {
        await getResults()
    }
})
</script>